(()=>{
  if(window.bbcProductTitleOrder)return;window.bbcProductTitleOrder=true;
  const observers=new Map();
  const mount=()=>document.querySelectorAll('[data-section-type="product"] form.ProductForm').forEach(form=>{
    if(form.closest('.BBCProductLayout')||observers.has(form))return;
    const place=()=>{
      const heading=form.querySelector('.desktop-title-section');
      const meta=heading?.querySelector('.ProductMeta');
      if(!meta)return;
      form.querySelectorAll('.sealsubs-target-element').forEach(widget=>{
        if(widget.parentElement.closest('.sealsubs-target-element'))return;
        if(widget.parentElement!==heading||!(meta.compareDocumentPosition(widget)&Node.DOCUMENT_POSITION_FOLLOWING))heading.append(widget);
      });
    };
    const observer=new MutationObserver(place);observer.observe(form,{childList:true,subtree:true});observers.set(form,observer);place();
  });
  document.addEventListener('shopify:section:load',mount);
  document.addEventListener('shopify:section:unload',e=>{for(const [form,observer] of observers)if(e.target.contains(form)){observer.disconnect();observers.delete(form);}});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
})();

